import getItemWidth from 'src/js/modules/control-pane/helpers/get-item-width';

const getItemsSize = (items) => {
  const itemsHeight = items.filter(({ height }) => height).map(({ height }) => height);

  const itemsWidth = items.filter(getItemWidth).map(getItemWidth);

  return { itemsHeight, itemsWidth };
};

export default getItemsSize;
